// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"80cffd9e","379":"d6c80a84"}[chunkId] + ".chunk.css";
};